import { cx } from '@emotion/css';
import type { FC } from 'react';

import { getBackgroundClassName } from '../../../utils';
import {
  footerBarClassName,
  footerBarContainerClassName,
  footerBarWrapperClassName,
} from '../Footer.constants';
import {
  footerBarContainerCss,
  footerBarContainerOffsetCss,
  footerBarCss,
  wrapperCss,
} from './styles';
import type { FooterBarProps } from './types';

export const FooterBar: FC<FooterBarProps> = ({ children, backgroundColor, hasSideNav }) => {
  return (
    <div
      data-testid="footer-bar"
      className={cx(footerBarWrapperClassName, getBackgroundClassName(backgroundColor), wrapperCss)}
    >
      <div
        className={cx(footerBarContainerClassName, footerBarContainerCss, {
          [footerBarContainerOffsetCss]: hasSideNav,
        })}
      >
        <div className={cx(footerBarClassName, footerBarCss)}>{children}</div>
      </div>
    </div>
  );
};
